<app-search-bar [filters]="filters" [showPrimaryBtn]="false"
  (formValueChange)="handleFormValueChange($event)"></app-search-bar>

<ng-container *ngIf="loading; else SetData">
  <app-skeleton-loader [count]="5" type="card-user"></app-skeleton-loader>
</ng-container>

<ng-template #SetData>
  <ng-container *ngIf="listUsers; else noData">
    <div class="list" *ngFor="let item of listUsers; let i = index">
      <app-card-user [user]="item"
        [codigo]="(pagination?.totalRecords ?? 0) - ((pagination?.pageNumber ?? 1) - 1) * (pagination?.pageSize ?? 10) - i"
        [nome]="item.userName" [email]="item.email" [telefone]="item.telefone" [registo]="item.dataCriacaoFormatada"
        [estado]="item.ativo" [actions]="actions(item)" (rowClick)="verDetalhe(item)"
        (menuOpened)="setOpenedMenu($any($event))">
      </app-card-user>
    </div>

    <div class="pagination-controls">
      <app-paginator-control [first]="
          ((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)
        " [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
        (pageChange)="onPageChange($event)">
      </app-paginator-control>
    </div>
  </ng-container>
</ng-template>

<p-drawer [(visible)]="visible" position="right" [style]="{ width: '700px' }"
  styleClass="!w-full md:!w-80 lg:!w-[30rem]" appendTo="body" [blockScroll]="true" [modal]="true">
  <ng-template #headless>
    @if (user) {
    <div class="drawer-body-wrapper">
      <app-detalhe-utilizador [utilizador]="user" (onCloseModal)="visible = false" />
    </div>
    }
  </ng-template>
</p-drawer>

<ng-template #noData>
  <div class="no-data">
    <app-data-void titulo="Nenhum utilizador encontrado" descricao="Tente novamente mais tarde."></app-data-void>
  </div>
</ng-template>

<p-confirmDialog appendTo="body"></p-confirmDialog>

<p-dialog header="Adicionar permissões ao utilizador" [modal]="true" [(visible)]="showModalAssociate"
  [style]="{ width: '35rem' }">
  <form [formGroup]="associateForm" class="p-fluid grid">
    <div class="field d-flex flex-column col-12">
      <label for="userName">utilizador</label>
      <input id="userName" formControlName="userName" pInputText placeholder="Usuário" class="w-full" />
    </div>
    <div class="field d-flex flex-column col-12">
      <label for="roleId">Permissões</label>
      <p-select [filter]="true" id="roleId" placeholder="Seleccione a permissão" appendTo="body"
        formControlName="roleId" class="w-full" [options]="listRoles" optionLabel="name" optionValue="id" />
      <div *ngIf="
          associateForm.get('roleId')?.invalid &&
          associateForm.get('roleId')?.touched
        " class="error-message text-red-600 mt-2">
        Permissão é obrigatória
      </div>
    </div>
  </form>
  <div class="flex justify-content-between w-full">
    <p-button label="Cancelar" severity="secondary" (click)="cancel()" />
    <button class="btn_one" (click)="saveUser()" [disabled]="disabled_btn">
      {{ loading ? "Salvando..." : "Salvar" }}
      <i class="pi pi-spinner" *ngIf="loading"></i>
    </button>
  </div>
</p-dialog>

<p-dialog header="Remover permissões do utilizador" [modal]="true" [(visible)]="showDesassociateModal"
  [style]="{ width: '35rem' }">
  <form [formGroup]="dissassociateForm" class="p-fluid grid">
    <div class="field d-flex flex-column col-12">
      <label for="userName">utilizador</label>
      <input id="userName" formControlName="userName" pInputText placeholder="Usuário" class="w-full" />
    </div>
    <div class="roles-list mb-4 col-12 w-100">
      <ng-container *ngIf="listRolesByUser.length; else noGroups">
        <div class="p-fluid grid roles-items w-100">
          <div *ngFor="let role of listRolesByUser" class="field col-12 w-100">
            <div class="flex align-items-center justify-content-between mb-2 w-full">
              <span>{{ role?.nome }}</span>
              <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="
                  RemoveUserFromGroup(
                    selectedUser?.userName || '',
                    role.id,
                    role.nome
                  )
                " pTooltip="Remover do grupo" tooltipPosition="top"></button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #noGroups>
        <p class="mt-3 text-muted">Usuário não tem nenhuma permissão.</p>
      </ng-template>
    </div>
  </form>
  <div class="flex justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showDesassociateModal = false" />
    <button class="btn_one" (click)="showDesassociateModal = false">
      fechar
    </button>
  </div>
</p-dialog>